import {Component, ElementRef, Input, OnInit} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {NgForOf, NgIf} from "@angular/common";
import {ExportToCsv} from "export-to-csv";
import {AlertService} from "../../services/alert.service";
import {Rule} from "../../services/capd.model";
import {RulesService} from "../../services/rules.service";
import {document} from "ngx-bootstrap/utils";
import {OrgService} from '../../services/org.service';

@Component({
    templateUrl: './library.component.html',
    imports: [
        FormsModule,
        NgForOf,
        NgIf,
        ReactiveFormsModule
    ]
})

export class LibraryComponentV2 implements OnInit {

    generatingExport = false
    requestedOidExport: string;
    enabledOptions: string;
    private exportAllData: any[]
    @Input() rules: Rule[];
    selectedRule: Rule = null;
    showOptionsDropdown: boolean = false;
    sortType = "triggerNameAsc"

    constructor(private _el: ElementRef,
                private alertService: AlertService,
                private _service: RulesService,
                private _orgService: OrgService
    ) {
    }

    ngOnInit() {
        this.updateList()
    }

    /**
     * Function called to create a csv export of rule assignments
     *
     * @func exportAllRulesCsv
     */
    async exportAllRulesCsv() {
        this.generatingExport = true;
        try {
            await this.getAllRulesForExport();
        } catch (e) {
            this.alertService.showAlert('Export failed!');
        }
        this.generatingExport = false;

        const options = {
            filename: 'all_rule_export_' + Date.now(),
            fieldSeparator: ',',
            quoteStrings: '"',
            decimalSeparator: '.',
            showLabels: true,
            showTitle: true,
            title: 'rule_export',
            useTextFile: false,
            useBom: true,
            useKeysAsHeaders: true
        };

        const csvExporter = new ExportToCsv(options);
        csvExporter.generateCsv(this.exportAllData);
    }

    /**
     * Function called to get all rule assignments for the csv
     *
     * @async
     * @func getAllRulesForExport
     */
    async getAllRulesForExport() {
        this.exportAllData = [];

        await this._service.getAllContent().then(res => {
            res.forEach((customRule: Rule) => {
                let state = '';
                if (customRule.triggerSilent) { state = 'Silent'; } else { state = 'Enabled'; }
                let tenantList = '""';
                if (customRule.customerTenants != null) {
                    tenantList = '"' + customRule.customerTenants.tenants + '"';
                }
                const ruleValue = {
                    'Client ID': customRule.orgId,
                    'Client Name': customRule.org_name,
                    'Client Tenant': tenantList.replaceAll('"', ''),
                    'Assigned Group': customRule.groupId,
                    'Rule Name': customRule.triggerName,
                    'Trigger Code': customRule.orgGroupRuleId.triggerCode,
                    'State': state,
                    'Priority': customRule.triggerPriority,
                    'Modified': customRule.triggerInfoModified,
                    'Physician Title': customRule.physicianTitle,
                    'Physician Message': customRule.physicianMessage,
                    'Delay Hours': customRule.delayHours
                };
                this.exportAllData.push(ruleValue);
            });
        });
        return this.exportAllData;
    }

    async getAllRulesForExportWithOptions() {
        this.exportAllData = [];

        await this._service.getAllContent(this.enabledOptions).then(res => {
            res.forEach((customRule: Rule) => {
                let state = '';
                if (customRule.triggerSilent) { state = 'Silent'; } else { state = 'Enabled'; }
                let tenantList = '""';
                if (customRule.customerTenants != null) {
                    tenantList = '"' + customRule.customerTenants.tenants + '"';
                }
                const ruleValue = {
                    'Client ID': customRule.orgId,
                    'Client Name': customRule.org_name,
                    'Client Tenant': tenantList.replaceAll('"', ''),
                    'Assigned Group': customRule.groupId,
                    'Rule Name': customRule.triggerName,
                    'Trigger Code': customRule.orgGroupRuleId.triggerCode,
                    'State': state,
                    'Priority': customRule.triggerPriority,
                    'Modified': customRule.triggerInfoModified,
                    'Physician Title': customRule.physicianTitle,
                    'Physician Message': customRule.physicianMessage,
                    'Delay Hours': customRule.delayHours
                };
                this.exportAllData.push(ruleValue);
            });
        });
        return this.exportAllData;
    }

    async getOrgRules() {
        this.exportAllData = [];

        await this._orgService.getOrgGroupContent(this.requestedOidExport).then(res => {
            res.forEach((customRule: Rule) => {
                let state = '';
                if (customRule.triggerSilent) { state = 'Silent'; } else { state = 'Enabled'; }

                const ruleValue = {
                    'Group ID': customRule.groupId,
                    'Group Name': customRule.groupName,
                    'Rule Name': customRule.triggerName,
                    'Trigger Code': customRule.triggerCode,
                    'State': state,
                    'Priority': customRule.triggerPriority,
                    'Modified': customRule.triggerModified,
                    'Physician Title': customRule.physicianTitle,
                    'Physician Message': customRule.physicianMessage,
                    'Delay Hours': customRule.delayHours
                };
                this.exportAllData.push(ruleValue);
            });
        });
    }


    showExportOptions() {
        this.requestedOidExport = null;
        this.enabledOptions = null;
        this.showOptionsDropdown = !this.showOptionsDropdown;
        if (this.showOptionsDropdown) {
            $(this._el.nativeElement).find('#exportOptionsDropdown').show();
        } else {
            $(this._el.nativeElement).find('#exportOptionsDropdown').hide();
        }
    }

    async exportAllRulesCsvWithOptions() {
        if (!this.enabledOptions) {
            this.enabledOptions = 'null';
        }
        this.generatingExport = true;
        await this.getAllRulesForExportWithOptions();
        this.generatingExport = false;

        const options = {
            filename: 'all_rule_export_' + Date.now(),
            fieldSeparator: ',',
            quoteStrings: '"',
            decimalSeparator: '.',
            showLabels: true,
            showTitle: true,
            title: 'rule_export',
            useTextFile: false,
            useBom: true,
            useKeysAsHeaders: true
        };

        const csvExporter = new ExportToCsv(options);
        if(this.exportAllData && this.exportAllData.length > 0) {
            csvExporter.generateCsv(this.exportAllData);
            $(this._el.nativeElement).find('#exportOptionsDropdown').toggle();
        } else {
            this.alertService.showAlert("No results.  Please ensure the Org ID is valid.");
        }
    }

    async exportOrgContent() {
        this.generatingExport = true;

        await this.getOrgRules();

        if (this.exportAllData && this.exportAllData.length > 0) {
            if (this.enabledOptions != null) {
                await this.filterOrgRules();
            }
        }

        this.generatingExport = false;

        const options = {
            filename: 'org_' + this.requestedOidExport + '_rules_export_' + Date.now(),
            fieldSeparator: ',',
            quoteStrings: '"',
            decimalSeparator: '.',
            showLabels: true,
            showTitle: true,
            title: 'rule_export',
            useTextFile: false,
            useBom: true,
            useKeysAsHeaders: true
        };

        const csvExporter = new ExportToCsv(options);
        if (this.exportAllData && this.exportAllData.length > 0) {
            csvExporter.generateCsv(this.exportAllData);
            $(this._el.nativeElement).find('#exportOptionsDropdown').toggle();
        } else {
            this.alertService.showAlert("No results.  Please ensure the Org ID is valid.");
        }
    }

    filterOrgRules() {
        let state = '';

        if (this.enabledOptions === 'true') {
            state = 'Silent';
        } else {
            state = 'Enabled';
        }


        this.exportAllData = this.exportAllData.filter(rule =>
            rule['State'] == state
        );

        return this.exportAllData;
    }

    performExport() {
        if (this.requestedOidExport == null) {
            this.exportAllRulesCsvWithOptions();
        } else {
            this.exportOrgContent();
        }
    }

    /**
     * Function called to both initialize and refresh the list of rules when any changes are made.
     *
     * @async
     * @func updateList
     * @param {string} ruleArg - if a specific rule has been changed, its ID is passed in to automatically
     *                           select it.
     */
    updateList(ruleArg?) {
        this._service.getRulesV2().then((rules: Rule[]) => {
            rules.sort(function(a, b) {
                const textA = a.triggerName.toUpperCase();
                const textB = b.triggerName.toUpperCase();

                // primary sort by trigger name
                if (textA !== textB) {
                    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                }

                // if trigger names are the same, then sort by trigger code which CAN BE text or number
                const codeA = parseFloat(a.triggerCode);
                const codeB = parseFloat(b.triggerCode);

                if (!isNaN(codeA) && !isNaN(codeB)) {
                    return codeA - codeB;
                } else if (!isNaN(codeA)) {
                    return -1;
                } else if (!isNaN(codeB)) {
                    return 1;
                } else {
                    const codeTextA = a.triggerCode.toUpperCase();
                    const codeTextB = b.triggerCode.toUpperCase();
                    return (codeTextA < codeTextB) ? -1 : (codeTextA > codeTextB) ? 1 : 0;
                }
            });
            this.rules = rules;
        }).then(() => {
            if (ruleArg) {
                this.findRule(ruleArg.triggerCode, ruleArg.triggerName);
            } else {
                this.selectedRule = null;
            }
        });
    }

    // used to find a newly created rule in the list of rules
    // auto scrolls to this roll and sets it as selected rule
    async findRule(triggerCode, triggerName) {
        let highlightedRule: Rule = this.rules.filter(rule => (rule.triggerCode == triggerCode) && (rule.triggerName == triggerName))[0]
        this.selectedRule = highlightedRule;
        let scrollto = document.getElementById('item' + triggerCode);
        try {
            scrollto.scrollIntoView();
        } catch (err) {
            console.log(err);
        }

    }

    /**
     * Selects a rule from the list.
     *
     * @func onSelect
     * @param {Rule} rule - the rule to select.
     */
    onSelect(rule: Rule) {
        this.selectedRule = rule;
    }

    /**
     * Checks to see if the current user has the ability to edit packages.
     *
     * @func hasPackageManagement
     * @returns {boolean} true if the user has the package-management permission and false otherwise.
     */
    hasManagementPermissions(): boolean {
        return sessionStorage.getItem('permissions').indexOf('package-management') > 0;
        // return false;
    }

    changeSortType(type) {
        this.sortType = type;
        this.sortRuleList();
        this.toggleSortDropdown();
    }

    toggleSortDropdown() {
        $(this._el.nativeElement).find('#sortOptions').toggle();
    }

    toggleRuleSearch() {
        $(this._el.nativeElement).find('#searchRules').toggle();
    }

    sortRuleList() {
        if (this.sortType === 'triggerNameAsc') {
            this.nameAscendingSort();
        } else if (this.sortType === 'triggerNameDesc') {
            this.nameDescendingSort();
        } else if (this.sortType === 'triggerCodeAsc') {
            this.codeAscendingSort();
        } else if (this.sortType === 'triggerCodeDesc') {
            this.codeDescendingSort();
        }
    }

    nameAscendingSort() {
        this.rules.sort(function(a, b) {
            var textA = a.triggerName.toUpperCase();
            var textB = b.triggerName.toUpperCase();
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        });
    }

    nameDescendingSort() {
        this.rules.sort(function(a, b) {
            var textA = a.triggerName.toUpperCase();
            var textB = b.triggerName.toUpperCase();
            return (textA < textB) ? 1 : (textA > textB) ? -1 : 0;
        });
    }

    codeAscendingSort() {
        this.rules.sort(function(a, b) {
            var textA = a.triggerCode.toUpperCase();
            var textB = b.triggerCode.toUpperCase();
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        });
    }

    codeDescendingSort() {
        this.rules.sort(function(a, b) {
            var textA = a.triggerCode.toUpperCase();
            var textB = b.triggerCode.toUpperCase();
            return (textA < textB) ? 1 : (textA > textB) ? -1 : 0;
        });
    }

    searchRules() {
        const input = document.getElementById('rulesearchbar').value.toLowerCase();
        let found = false;

        this.rules.forEach(r => {
            if (!r.triggerCode.toLowerCase().includes(input) && !r.triggerName.toLowerCase().includes(input)) {
                document.getElementById('item' + r.triggerCode).style.display = "none";
            } else {
                document.getElementById('item' + r.triggerCode).style.display = "list-item";
                found = true;
            }
        });

        if (!found) {
            this.alertService.showAlert("No result found.");
        }
    }
}
